import {PepStatus} from '../dto/pep-status';
import {IdentStatus} from "../dto/ident-status";

export const getIdentStatusColor = (identStatus: IdentStatus) => {
  if ( identStatus == IdentStatus.success ) {
    return '#8bc34a';
  }
  if ( identStatus == IdentStatus.fail ) {
    return '#ff0000';
  }
  if ( identStatus == IdentStatus.expired ) {
    return 'grey';
  }
  if ( identStatus == IdentStatus.abandoned ) {
    return 'grey';
  }

  return 'black';
};
export const getIdentStatusIcon = (identStatus: IdentStatus) => {
  if ( identStatus == IdentStatus.success ) {
    return 'beenhere';
  }
  return null;
};
export const getIdentStatusText = (identStatus: IdentStatus) => {
  if ( identStatus == IdentStatus.success ) {
    return 'Success';
  }
  if ( identStatus == IdentStatus.fail ) {
    return 'Failed';
  }
  if ( identStatus == IdentStatus.expired ) {
    return 'Expired';
  }
  if ( identStatus == IdentStatus.abandoned ) {
    return 'Abandoned';
  }

  return null;
};

export const getPepStatusColor = (pepStatus: PepStatus) => {
  if (pepStatus == PepStatus.possibleMatch) {
    return '#ff9900';
  }
  if (pepStatus == PepStatus.confirmedMatch) {
    return '#ff0000';
  }
  if (pepStatus == PepStatus.pending) {
    return '#547bde';
  }
  if (pepStatus == PepStatus.noMatch || pepStatus == PepStatus.falsePositive) {
    return '#8bc34a';
  }
  if (pepStatus == null) {
    return 'grey';
  }
  return null;
};

export const getPepStatusText = (pepStatus: PepStatus) => {
  if (pepStatus == PepStatus.possibleMatch) {
    return 'Possible match';
  }
  if (pepStatus == PepStatus.confirmedMatch) {
    return 'Confirmed match';
  }
  if (pepStatus == PepStatus.pending) {
    return 'Pending';
  }
  if (pepStatus == PepStatus.noMatch) {
    return 'No match';
  }
  if (pepStatus == PepStatus.falsePositive) {
    return 'No match (false positive)';
  }
  if (pepStatus == null) {
    return 'No PEP check yet';
  }
};
